import t from "./ExpandMoreRounded.mjs";
const n = {
  defaultProps: {
    IconComponent: t
  },
  styleOverrides: {
    iconOutlined: ({ theme: e }) => ({
      right: e.tokens.spacing[12]
    })
  }
};
export {
  n as select
};
//# sourceMappingURL=select2.mjs.map
